import Client from '@/hosted_fields/common/connection/client';
import CardFormatter from '@/hosted_fields/component/card-formatter';
import BaseFactory from './base-factory';
import {MessageData} from '@/hosted_fields/common/types';

export default class CardCVV extends BaseFactory {
  constructor(client: Client, data: MessageData) {
    super(client, data);
  }

  // @override
  addListeners(id: string) {
    super.addListeners(id);
    let el = document.getElementById(id);
    if (el) CardFormatter.formatCardCVC(el);
  }
}
